import React from 'react';
import MathQuiz from 'views/MathQuiz';

const MathClubPage = () => {
  return <MathQuiz/>;
};

export default MathClubPage;

